<script>
  import CancelCircleWhite from '@/assets/images/svg/icons/cancel-circle-white.svg';

  const ORIENTATION = {
    Portrait: 'portrait',
    Landscape: 'landscape',
  };

  export default {
    name: 'VideoPopup',

    emits: ['close'],

    components: {
      CancelCircleWhite,
    },

    data: () => ({
      videoSrc: '',
      popupElement: null,
    }),

    computed: {
      showDialog() {
        return this.$store.state.dialog.showVideoPopup;
      },

      orientation() {
        return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width
          ? ORIENTATION.Portrait
          : ORIENTATION.Landscape;
      },

      videoUrl() {
        return this.orientation === ORIENTATION.Landscape
          ? '/images/animations/MaxQuest_Introduction-PVP-Experience_16-9_Website_fixed.mp4?v=1'
          : '/images/animations/MaxQuest_Introduction-PVP-Experience_9-16_Website_fixed.mp4?v=1';
      },
    },

    watch: {
      async showDialog(val) {
        if (val) {
          this.videoSrc = this.videoUrl;

          await this.$nextTick();

          if (this.$refs.video) {
            this.$refs.video.volume = 0.4;
          }

          this.setListeners();
        } else {
          this.videoSrc = '';
          this.removeListeners();
        }
      },
    },

    methods: {
      closeDialog() {
        this.$emit('close');
        this.$store.commit('SET_SHOW_VIDEO_POPUP', false);
      },

      onDialogClick(e) {
        if (e.target !== this.popupElement) return;
        this.closeDialog();
      },

      setListeners() {
        this.popupElement = document.querySelector('.video-popup');
        this.popupElement?.addEventListener('click', this.onDialogClick);
      },

      removeListeners() {
        this.popupElement?.removeEventListener('click', this.onDialogClick);
        this.popupElement = null;
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    content-class="video-popup"
    fullscreen
    persistent
    width="100%"
    @click="closeDialog"
    @keydown.esc="closeDialog"
  >
    <div @click="closeDialog">
      <div class="popup-content">
        <video ref="video" autoplay controls width="100%">
          <source :src="videoSrc" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <CancelCircleWhite class="close-button" @click="closeDialog" />
      </div>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .popup-content {
    display: flex;
    justify-content: center;
    position: relative;
    width: calc(100% - 40px);
    max-height: 100vh;
    margin-inline: auto;

    video {
      max-height: calc(100vh - 100px);
      border-radius: 10px;
    }

    @media screen and (max-width: 800px) {
      max-width: 394px;
    }

    @media screen and (min-width: 1200px) {
      max-width: 88vw;
    }

    @media screen and (min-width: 1600px) {
      max-width: 1440px;
    }
  }

  .close-button {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -50px;
    right: 0;
    cursor: pointer;

    @media screen and (min-width: 1200px) {
      top: 0;
      right: -60px;
    }
  }
</style>

<style lang="scss">
  .video-popup {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.8) !important;
  }
</style>
